const DEFAULT_MOCK_DELAY_MS = 300

export const mockDelay = (ms = DEFAULT_MOCK_DELAY_MS) => new Promise<void>((r) => setTimeout(r, ms))
